export default __webpack_public_path__ + "static/media/download.aeab5c20.jpeg";